// import React, { useEffect, useMemo, useState } from "react";
// import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
// import CommonReactTable from "../CommonUtils/CommonReactTable";
// import { config } from "../CommonUtils/CommonURLS";
// import * as bie from "react-bootstrap";
// import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";

// export default function SubjectConsolidatedReport() {
//     const facultyDetailsFormik = useFormik({
//         initialValues: { university: "" },
//         enableReinitialize: true,
//         onSubmit: (val) => { console.log("Submit", val); },
//     });

//     const [projectdata, setProjectdata] = useState([]);
//     const [subject, setSubject] = useState([]);
//     const [showDetails, setShowDetails] = useState(null);
//     const [ubcode, setUbcode] = useState("");
//     // Fetch university list
//     function GetProjectStatusData() {
//         const url = `${config.url.FAC_URL}getUnvsubWiseReport`;
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === "01" && res?.data?.UnivsubWiseReport?.length > 0) {
//                 setProjectdata(res?.data?.UnivsubWiseReport);
//             } else {
//                 setProjectdata([]);
//             }
//         });
//     }

//     function GetSubjectData(ubcode, desg) {
//         setUbcode(ubcode);
//         console.log("Selected UBCode:", ubcode);
//         const url = `${config.url.FAC_URL}getSubjectwiseReport?ubCode=${ubcode}&desg=${desg}`;
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === "01") {
//                 setSubject(res?.data?.subj_wise_details || []);
//                 setShowDetails(true);
//             } else {
//                 setSubject([]);
//                 setShowDetails(false);
//             }
//         });
//     }

//     useEffect(() => { GetProjectStatusData(); }, []);



//     const formattedData = React.useMemo(() => {
//         return (subject || []).map((item) => ({
//             dept_name: item.dept_name,

//             // Professor
//             prof_san: item.prof_no_of_san_posts || 0,
//             prof_adhoc: item.prof_no_of_adhoc_fac_working || 0,
//             prof_guest: item.prof_no_of_guest_fac_working || 0,
//             prof_reg: item.prof_no_of_reg_fac_working || 0,
//             prof_contract: item.prof_no_of_contract_fac_working || 0,

//             // Associate Professor
//             assoc_san: item.assoc_prof_no_of_san_posts || 0,
//             assoc_adhoc: item.assoc_prof_no_of_adhoc_fac_working || 0,
//             assoc_guest: item.assoc_prof_no_of_guest_fac_working || 0,
//             assoc_reg: item.assoc_prof_no_of_reg_fac_working || 0,
//             assoc_contract: item.assoc_prof_no_of_contract_fac_working || 0,

//             // Assistant Professor
//             asst_san: item.asst_prof_no_of_san_posts || 0,
//             asst_adhoc: item.asst_prof_no_of_adhoc_fac_working || 0,
//             asst_guest: item.asst_prof_no_of_guest_fac_working || 0,
//             asst_reg: item.asst_prof_no_of_reg_fac_working || 0,
//             asst_contract: item.asst_prof_no_of_contract_fac_working || 0,
//         }));
//     }, [subject]);
//     const SubjectConsolidatedColumns = [
//         { id: "slNo", header: "Sl.No", cell: ({ row }) => row.index + 1, color: "#F5F5F5" },
//         {
//             id: "dept_name", header: "Department", accessorKey: "dept_name", Footer: "Total", color: "#F5F5F5", textColor: "#0a0c0c"
//         },

//         {
//             id: "professor", header: "Professor (At the time of Appointment)", columns: [
//                 {
//                     id: "prof_san", header: "No of Sanctioned Posts", accessorKey: "prof_san", Footer: true, color: "#E3F2FD", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "prof_adhoc", header: "No of Adhoc Faculty Working", accessorKey: "prof_adhoc", Footer: true, color: "#E3F2FD", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "prof_guest", header: "No of Guest Faculty Working", accessorKey: "prof_guest", Footer: true, color: "#E3F2FD", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "prof_reg", header: "No of Regular Faculty Working", accessorKey: "prof_reg", Footer: true, color: "#E3F2FD", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "prof_contract", header: "No of Contract Faculty Working", accessorKey: "prof_contract", Footer: true, color: "#E3F2FD", textColor: "#0a0c0c"
//                 },


//                 {
//                     id: "prof_vacancy",
//                     header: "No of Vacancies",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.prof_san) || 0) -
//                         (Number(row.original.prof_reg) || 0),
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.prof_san) || 0) -
//                             (Number(row.original.prof_reg) || 0),
//                             0
//                         );
//                         return <strong>{total}</strong>;
//                     },
//                     color: "#E3F2FD", textColor: "#0a0c0c"
//                 },
//             ]
//         },

//         {
//             id: "assoc_professor", header: "Associate Professor  (At the time of Appointment)", columns: [
//                 {
//                     id: "assoc_san", header: "No of Sanctioned Posts", accessorKey: "assoc_san", Footer: true, color: "#E8F5E9", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "assoc_adhoc", header: "No of Adhoc Faculty Working", accessorKey: "assoc_adhoc", Footer: true, color: "#E8F5E9", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "assoc_guest", header: "No of Guest Faculty Working", accessorKey: "assoc_guest", Footer: true, color: "#E8F5E9", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "assoc_reg", header: "No of Regular Faculty Working", accessorKey: "assoc_reg", Footer: true, color: "#E8F5E9", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "assoc_contract", header: "No of Contract Faculty Working", accessorKey: "assoc_contract", Footer: true, color: "#E8F5E9", textColor: "#0a0c0c"
//                 },

//                 {
//                     id: "assoc_vacancy",
//                     header: "No of Vacancies",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.assoc_san) || 0) -
//                         (Number(row.original.assoc_reg) || 0),
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.assoc_san) || 0) -
//                             (Number(row.original.assoc_reg) || 0),
//                             0
//                         );
//                         return <strong>{total}</strong>;
//                     },
//                     color: "#E8F5E9", textColor: "#0a0c0c"
//                 },

//             ]
//         },

//         {
//             id: "asst_professor", header: "Assistant Professor  (At the time of Appointment)", columns: [
//                 {
//                     id: "asst_san", header: "No of Sanctioned Posts", accessorKey: "asst_san", Footer: true, color: "#FFFDE7", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "asst_adhoc", header: "No of Adhoc Faculty Working", accessorKey: "asst_adhoc", Footer: true, color: "#FFFDE7", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "asst_guest", header: "No of Guest Faculty Working", accessorKey: "asst_guest", Footer: true, color: "#FFFDE7", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "asst_reg", header: "No of Regular Faculty Working", accessorKey: "asst_reg", Footer: true, color: "#FFFDE7", textColor: "#0a0c0c"
//                 },
//                 {
//                     id: "asst_contract", header: "No of Contract Faculty Working", accessorKey: "asst_contract", Footer: true, color: "#FFFDE7", textColor: "#0a0c0c"
//                 },

//                 {
//                     id: "asst_vacancy",
//                     header: "No of Vacancies",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.asst_san) || 0) -
//                         (Number(row.original.asst_reg) || 0),
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.asst_san) || 0) -
//                             (Number(row.original.asst_reg) || 0),
//                             0
//                         );
//                         return <b>{total}</b>;
//                     },
//                     color: "#FFFDE7", textColor: "#0a0c0c"
//                 },




//             ]
//         },

//         ...(ubcode === "U-0632" || ubcode === "all"
//             ? [
//                 {
//                     id: "lecturer",
//                     header: "Lecturer (At the time of Appointment)",
//                     columns: [
//                         {
//                             id: "lect_no_of_san_posts",
//                             header: "No of Sanctioned Posts",
//                             accessorKey: "lect_no_of_san_posts",
//                             Footer: true,
//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         },
//                         {
//                             id: "lect_no_of_adhoc_fac_working",
//                             header: "No of Adhoc Faculty Working",
//                             accessorKey: "lect_no_of_adhoc_fac_working",
//                             Footer: true,
//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         },
//                         {
//                             id: "lect_no_of_guest_fac_working",
//                             header: "No of Guest Faculty Working",
//                             accessorKey: "lect_no_of_guest_fac_working",
//                             Footer: true,
//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         },
//                         {
//                             id: "lect_no_of_reg_fac_working",
//                             header: "No of Regular Faculty Working",
//                             accessorKey: "lect_no_of_reg_fac_working",
//                             Footer: true,
//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         },
//                         {
//                             id: "lect_no_of_contract_fac_working",
//                             header: "No of Contract Faculty Working",
//                             accessorKey: "lect_no_of_contract_fac_working",
//                             Footer: true,
//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         },
//                         {
//                             id: "lect_vacancy",
//                             header: "No of Vacancies",
//                             meta: {
//                                 style: { textAlign: "right" }
//                             },

//                             cell: ({ row }) =>
//                                 (Number(row.original.lect_no_of_san_posts) || 0) -
//                                 (Number(row.original.lect_no_of_reg_fac_working) || 0),

//                             Footer: ({ table }) => {
//                                 const total = table.getRowModel().rows.reduce(
//                                     (sum, row) =>
//                                         sum +
//                                         (
//                                             (Number(row.original.lect_no_of_san_posts) || 0) -
//                                             (Number(row.original.lect_no_of_reg_fac_working) || 0)
//                                         ),
//                                     0
//                                 );

//                                 return <b>{total}</b>;
//                             },

//                             color: "#FFFDE7",
//                             textColor: "#0a0c0c"
//                         }
//                     ]
//                 }
//             ]
//             : []
//         ),

//         {
//             id: "total", header: "TOTAL", columns: [
//                 {
//                     id: "total_sanctioned", header: "No of Sanctioned Posts",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.prof_san) || 0) +
//                         (Number(row.original.assoc_san) || 0) +
//                         (Number(row.original.lect_no_of_san_posts) || 0) +

//                         (Number(row.original.asst_san) || 0),

//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.prof_san) || 0) +
//                             (Number(row.original.assoc_san) || 0) +
//                             (Number(row.original.lect_no_of_san_posts) || 0) +

//                             (Number(row.original.asst_san) || 0),
//                             0
//                         );
//                         return <strong>{total}</strong>;
//                     },
//                     color: "#f7eeef",
//                     textColor: "#B71C1C"

//                 },
//                 {
//                     id: "total_regular", header: "No of Regular Faculty Working",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.prof_reg) || 0) +
//                         (Number(row.original.assoc_reg) || 0) +
//                         (Number(row.original.lect_no_of_reg_fac_working) || 0) +

//                         (Number(row.original.asst_reg) || 0),
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.prof_reg) || 0) +
//                             (Number(row.original.assoc_reg) || 0) +
//                             (Number(row.original.lect_no_of_reg_fac_working) || 0) +
//                             (Number(row.original.asst_reg) || 0),
//                             0
//                         );
//                         return <strong>{total}</strong>;
//                     },
//                     color: "#f7eeef",
//                     textColor: "#B71C1C"
//                 },
//                 {
//                     id: "total_contract", header: "No of Contract Faculty Working",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) =>
//                         (Number(row.original.prof_contract) || 0) +
//                         (Number(row.original.assoc_contract) || 0) +
//                         (Number(row.original.lect_no_of_contract_fac_working) || 0) +
//                         (Number(row.original.asst_contract) || 0),
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) =>
//                             sum +
//                             (Number(row.original.prof_contract) || 0) +
//                             (Number(row.original.assoc_contract) || 0) +
//                             (Number(row.original.lect_no_of_contract_fac_working) || 0) +
//                             (Number(row.original.asst_contract) || 0),
//                             0
//                         );
//                         return <strong>{total}</strong>;
//                     },
//                     color: "#f7eeef",
//                     textColor: "#B71C1C"

//                 },

//                 {
//                     id: "total_vacancies",
//                     header: "No of Vacancies",
//                     meta: { style: { textAlign: "right" } },
//                     cell: ({ row }) => {
//                         const sanctioned =
//                             (Number(row.original.prof_san) || 0) +
//                             (Number(row.original.assoc_san) || 0) +
//                             (Number(row.original.lect_no_of_san_posts) || 0) +
//                             (Number(row.original.asst_san) || 0);

//                         const regular =
//                             (Number(row.original.prof_reg) || 0) +
//                             (Number(row.original.assoc_reg) || 0) +
//                             (Number(row.original.lect_no_of_reg_fac_working) || 0) +
//                             (Number(row.original.asst_reg) || 0);

//                         return sanctioned - regular;
//                     },
//                     Footer: ({ table }) => {
//                         const total = table.getRowModel().rows.reduce((sum, row) => {
//                             const sanctioned =
//                                 (Number(row.original.prof_san) || 0) +
//                                 (Number(row.original.assoc_san) || 0) +
//                                 (Number(row.original.lect_no_of_san_posts) || 0) +
//                                 (Number(row.original.asst_san) || 0);

//                             const regular =
//                                 (Number(row.original.prof_reg) || 0) +
//                                 (Number(row.original.assoc_reg) || 0) +
//                                 (Number(row.original.lect_no_of_reg_fac_working) || 0) +
//                                 (Number(row.original.asst_reg) || 0);

//                             return sum + (sanctioned - regular);
//                         }, 0);

//                         return <strong>{total}</strong>;
//                     },
//                     color: "#f7eeef",
//                     textColor: "#B71C1C"
//                 }


//             ]
//         }
//     ];
//     // "ubcode": "U-0632",
//     return (
//         <div className="faculty-form-wrapper">
//             <div className="faculty-card">
//                 <div className="overal-stathead"><span>Subject Consolidated Report</span></div>

//                 <FormikProvider value={facultyDetailsFormik}>
//                     <Form onSubmit={facultyDetailsFormik?.handleSubmit} onChange={facultyDetailsFormik?.handleChange}>
//                         <bie.Row>
//                             <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} className="mb-2">
//                                 <label>Select University</label>
//                                 <Field as="select" name="university" className="form-control form-control-md"
//                                     onChange={(e) => { GetSubjectData(e.target.value, "all"); }}>
//                                     <option value="">---Select---</option>
//                                     {projectdata?.map((u) => (
//                                         <option key={u.ubcode} value={u.ubcode}>{u.univ_name}</option>
//                                     ))}
//                                     <option value='all'>ALL</option>

//                                 </Field>
//                                 <ErrorMessage name="university" component="div" className="text-danger" />
//                             </bie.Col>
//                         </bie.Row>
//                     </Form>
//                 </FormikProvider>

//                 {formattedData?.length > 0 ? (<>
//                     <div className="table-responsive pt-3">
//                         <CommonReactTable
//                             data={formattedData}
//                             columns={SubjectConsolidatedColumns}
//                             headerName="Subject Consolidated Report"
//                             showPagination={false}
//                             showFooter={true}
//                             showPrint={true}
//                             showExcel={true}
//                             excelFileName="Subject Consolidated Report"
//                         />
//                     </div></>
//                 ) : (
//                     showDetails === false && <center className="text-danger mt-4 h5">***** No Data Found *****</center>
//                 )}




//             </div>
//         </div>
//     );
// }
import React, { useEffect, useMemo, useState } from "react";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";
import * as bie from "react-bootstrap";
import {
    ErrorMessage,
    Field,
    Form,
    FormikProvider,
    useFormik
} from "formik";

export default function SubjectConsolidatedReport() {

    const facultyDetailsFormik = useFormik({
        initialValues: { university: "" },
        enableReinitialize: true,
        onSubmit: (val) => {
            console.log("Submit", val);
        }
    });

    const [projectdata, setProjectdata] = useState([]);
    const [subject, setSubject] = useState([]);
    const [showDetails, setShowDetails] = useState(null);
    const [ubcode, setUbcode] = useState("");

    // ================= GET UNIVERSITY DATA =================

    function GetProjectStatusData() {
        const url = `${config.url.FAC_URL}getUnvsubWiseReport`;

        CommonAxiosGet(url).then((res) => {
            if (
                res?.data?.scode === "01" &&
                res?.data?.UnivsubWiseReport?.length > 0
            ) {
                setProjectdata(res?.data?.UnivsubWiseReport);
            } else {
                setProjectdata([]);
            }
        });
    }

    // ================= GET SUBJECT DATA =================

    function GetSubjectData(ubcode, desg) {
        setUbcode(ubcode);

        const url =
            `${config.url.FAC_URL}getSubjectwiseReport?ubCode=${ubcode}&desg=${desg}`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setSubject(res?.data?.subj_wise_details || []);
                setShowDetails(true);
            } else {
                setSubject([]);
                setShowDetails(false);
            }
        });
    }

    useEffect(() => {
        GetProjectStatusData();
    }, []);

    // ================= FORMATTED DATA =================

    const formattedData = useMemo(() => {
        return (subject || []).map((item) => ({

            dept_name: item.dept_name,

            // PROFESSOR
            prof_san: item.prof_no_of_san_posts || 0,
            prof_adhoc: item.prof_no_of_adhoc_fac_working || 0,
            prof_guest: item.prof_no_of_guest_fac_working || 0,
            prof_reg: item.prof_no_of_reg_fac_working || 0,
            prof_contract: item.prof_no_of_contract_fac_working || 0,
            prof_rgukt_mentor: item.prof_no_rgukt_mentor || 0,


            // ASSOCIATE PROFESSOR
            assoc_san: item.assoc_prof_no_of_san_posts || 0,
            assoc_adhoc: item.assoc_prof_no_of_adhoc_fac_working || 0,
            assoc_guest: item.assoc_prof_no_of_guest_fac_working || 0,
            assoc_reg: item.assoc_prof_no_of_reg_fac_working || 0,
            assoc_contract: item.assoc_prof_no_of_contract_fac_working || 0,
            assoc_academic_consultant: item.assoc_prof_no_academic_consultant || 0,
            assoc_rgukt_mentor: item.assoc_prof_no_rgukt_mentor || 0,



            // ASSISTANT PROFESSOR
            asst_san: item.asst_prof_no_of_san_posts || 0,
            asst_adhoc: item.asst_prof_no_of_adhoc_fac_working || 0,
            asst_guest: item.asst_prof_no_of_guest_fac_working || 0,
            asst_reg: item.asst_prof_no_of_reg_fac_working || 0,
            asst_contract: item.asst_prof_no_of_contract_fac_working || 0,
            asst_rgukt_mentor: item.asst_prof_no_rgukt_mentor || 0,

            // LECTURER
            lect_san: item.lect_no_of_san_posts || 0,
            lect_adhoc: item.lect_no_of_adhoc_fac_working || 0,
            lect_guest: item.lect_no_of_guest_fac_working || 0,
            lect_reg: item.lect_no_of_reg_fac_working || 0,
            lect_contract: item.lect_no_of_contract_fac_working || 0,
            lect_rgukt_mentor: item.lect_prof_no_rgukt_mentor || 0,

        }));
    }, [subject]);

    // ================= COMMON COLUMN FUNCTION =================

    const createFacultyColumns = (
        prefix,
        title,
        color
    ) => ({
        id: prefix,
        header: title,

        columns: [

            {
                id: `${prefix}_san`,
                header: "No of Sanctioned Posts",
                accessorKey: `${prefix}_san`,
                Footer: true,
                color,
                textColor: "#0a0c0c"
            },

            {
                id: `${prefix}_adhoc`,
                header: "No of Adhoc Faculty Working",
                accessorKey: `${prefix}_adhoc`,
                Footer: true,
                color,
                textColor: "#0a0c0c"
            },

            {
                id: `${prefix}_guest`,
                header: "No of Guest Faculty Working",
                accessorKey: `${prefix}_guest`,
                Footer: true,
                color,
                textColor: "#0a0c0c"
            },

            {
                id: `${prefix}_reg`,
                header: "No of Regular Faculty Working",
                accessorKey: `${prefix}_reg`,
                Footer: true,
                color,
                textColor: "#0a0c0c"
            },

            {
                id: `${prefix}_contract`,
                header: "No of Contract Faculty Working",
                accessorKey: `${prefix}_contract`,
                Footer: true,
                color,
                textColor: "#0a0c0c"
            },
            ...(prefix === "assoc"
                ? [
                    {
                        id: `${prefix}_academic_consultant`,
                        header: "No of Academic Consultants",
                        accessorKey: "assoc_academic_consultant",
                        Footer: true,
                        color,
                        textColor: "#0a0c0c"
                    }
                ]
                : []),
            ...(ubcode === "U-0632" || ubcode === "all"
                ? [
                    {
                        id: `${prefix}_rgukt_mentor`,
                        header: "No of RGUKT Mentors",
                        accessorKey: `${prefix}_rgukt_mentor`,
                        Footer: true,
                        color,
                        textColor: "#0a0c0c"
                    }
                ]
                : []),


            {
                id: `${prefix}_vacancy`,
                header: "No of Vacancies",

                meta: {
                    style: { textAlign: "right" }
                },

                cell: ({ row }) =>
                    (Number(row.original[`${prefix}_san`]) || 0) -
                    (Number(row.original[`${prefix}_reg`]) || 0),

                Footer: ({ table }) => {

                    const total =
                        table.getRowModel().rows.reduce(
                            (sum, row) =>
                                sum +
                                (
                                    (Number(row.original[`${prefix}_san`]) || 0) -
                                    (Number(row.original[`${prefix}_reg`]) || 0)
                                ),
                            0
                        );

                    return <strong>{total}</strong>;
                },

                color,
                textColor: "#0a0c0c"
            }

        ]
    });
    console.log(formattedData);
    // ================= TABLE COLUMNS =================

    const SubjectConsolidatedColumns = [

        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
            color: "#F5F5F5"
        },

        {
            id: "dept_name",
            header: "Department",
            accessorKey: "dept_name",
            Footer: "Total",
            color: "#F5F5F5",
            textColor: "#0a0c0c"
        },

        createFacultyColumns(
            "prof",
            "Professor (At the time of Appointment)",
            "#E3F2FD"
        ),

        createFacultyColumns(
            "assoc",
            "Associate Professor (At the time of Appointment)",
            "#E8F5E9"
        ),

        createFacultyColumns(
            "asst",
            "Assistant Professor (At the time of Appointment)",
            "#FFFDE7"
        ),

        ...(ubcode === "U-0632" || ubcode === "all"
            ? [
                createFacultyColumns(
                    "lect",
                    "Lecturer (At the time of Appointment)",
                    "#FFFDE7"
                )
            ]
            : []
        ),

        // ================= TOTAL =================

        {
            id: "total",
            header: "TOTAL",

            columns: [

                {
                    id: "total_sanctioned",
                    header: "No of Sanctioned Posts",

                    cell: ({ row }) =>
                        (Number(row.original.prof_san) || 0) +
                        (Number(row.original.assoc_san) || 0) +
                        (Number(row.original.asst_san) || 0) +
                        (Number(row.original.lect_san) || 0),

                    Footer: ({ table }) => {

                        const total =
                            table.getRowModel().rows.reduce(
                                (sum, row) =>
                                    sum +
                                    (Number(row.original.prof_san) || 0) +
                                    (Number(row.original.assoc_san) || 0) +
                                    (Number(row.original.asst_san) || 0) +
                                    (Number(row.original.lect_san) || 0),
                                0
                            );

                        return <strong>{total}</strong>;
                    },

                    color: "#f7eeef",
                    textColor: "#B71C1C"
                },

                {
                    id: "total_regular",
                    header: "No of Regular Faculty Working",

                    cell: ({ row }) =>
                        (Number(row.original.prof_reg) || 0) +
                        (Number(row.original.assoc_reg) || 0) +
                        (Number(row.original.asst_reg) || 0) +
                        (Number(row.original.lect_reg) || 0),

                    Footer: ({ table }) => {

                        const total =
                            table.getRowModel().rows.reduce(
                                (sum, row) =>
                                    sum +
                                    (Number(row.original.prof_reg) || 0) +
                                    (Number(row.original.assoc_reg) || 0) +
                                    (Number(row.original.asst_reg) || 0) +
                                    (Number(row.original.lect_reg) || 0),
                                0
                            );

                        return <strong>{total}</strong>;
                    },

                    color: "#f7eeef",
                    textColor: "#B71C1C"
                },

                {
                    id: "total_contract",
                    header: "No of Contract Faculty Working",

                    cell: ({ row }) =>
                        (Number(row.original.prof_contract) || 0) +
                        (Number(row.original.assoc_contract) || 0) +
                        (Number(row.original.asst_contract) || 0) +
                        (Number(row.original.lect_contract) || 0),

                    Footer: ({ table }) => {

                        const total =
                            table.getRowModel().rows.reduce(
                                (sum, row) =>
                                    sum +
                                    (Number(row.original.prof_contract) || 0) +
                                    (Number(row.original.assoc_contract) || 0) +
                                    (Number(row.original.asst_contract) || 0) +
                                    (Number(row.original.lect_contract) || 0),
                                0
                            );

                        return <strong>{total}</strong>;
                    },

                    color: "#f7eeef",
                    textColor: "#B71C1C"
                },

                {
                    id: "total_vacancies",
                    header: "No of Vacancies",

                    cell: ({ row }) => {

                        const sanctioned =
                            (Number(row.original.prof_san) || 0) +
                            (Number(row.original.assoc_san) || 0) +
                            (Number(row.original.asst_san) || 0) +
                            (Number(row.original.lect_san) || 0);

                        const regular =
                            (Number(row.original.prof_reg) || 0) +
                            (Number(row.original.assoc_reg) || 0) +
                            (Number(row.original.asst_reg) || 0) +
                            (Number(row.original.lect_reg) || 0);

                        return sanctioned - regular;
                    },

                    Footer: ({ table }) => {

                        const total =
                            table.getRowModel().rows.reduce((sum, row) => {

                                const sanctioned =
                                    (Number(row.original.prof_san) || 0) +
                                    (Number(row.original.assoc_san) || 0) +
                                    (Number(row.original.asst_san) || 0) +
                                    (Number(row.original.lect_san) || 0);

                                const regular =
                                    (Number(row.original.prof_reg) || 0) +
                                    (Number(row.original.assoc_reg) || 0) +
                                    (Number(row.original.asst_reg) || 0) +
                                    (Number(row.original.lect_reg) || 0);

                                return sum + (sanctioned - regular);

                            }, 0);

                        return <strong>{total}</strong>;
                    },

                    color: "#f7eeef",
                    textColor: "#B71C1C"
                }

            ]
        }
    ];

    // ================= UI =================

    return (
        <div className="faculty-form-wrapper">

            <div className="faculty-card">

                <div className="overal-stathead">
                    <span>Subject Consolidated Report</span>
                </div>

                <FormikProvider value={facultyDetailsFormik}>

                    <Form onSubmit={facultyDetailsFormik.handleSubmit} onChange={facultyDetailsFormik.handleChange}>
                        <bie.Row>

                            <bie.Col
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                xl={4}
                                className="mb-2">

                                <label>Select University</label>

                                <Field
                                    as="select"
                                    name="university"
                                    className="form-control form-control-md"
                                    onChange={(e) => { GetSubjectData(e.target.value, "all"); }}>

                                    <option value="">---Select---</option>

                                    {projectdata?.map((u) => (
                                        <option key={u.ubcode} value={u.ubcode}>{u.univ_name}</option>))
                                    }

                                    <option value="all">ALL</option>

                                </Field>

                                <ErrorMessage
                                    name="university"
                                    component="div"
                                    className="text-danger"
                                />

                            </bie.Col>

                        </bie.Row>

                    </Form>

                </FormikProvider>

                {formattedData?.length > 0 ? (

                    <div className="table-responsive pt-3">

                        <CommonReactTable
                            data={formattedData}
                            columns={SubjectConsolidatedColumns}
                            headerName="Subject Consolidated Report"
                            showPagination={false}
                            showFooter={true}
                            showPrint={true}
                            showExcel={true}
                            excelFileName="Subject Consolidated Report"
                        />

                    </div>

                ) : (
                    showDetails === false &&
                    <center className="text-danger mt-4 h5">
                        ***** No Data Found *****
                    </center>
                )
                }

            </div>

        </div>
    );
}